import React from "react";
import { useParams } from "react-router-dom";

import Loading from "components/Loading";
import NewWorkbookButton from "components/NewWorkbookButton";
import WorkbookListTable from "components/WorkbookListTable";

import { useWorkbooksForOrganizationQuery } from "./gql/Query.generated";

const OrganizationWorkbookList = () => {
  const { slug } = useParams();
  const { loading, error, data, refetch } = useWorkbooksForOrganizationQuery({
    variables: { organizationSlug: slug },
  });

  if (loading || error || !data) {
    return <Loading error={!!error} />;
  }

  return (
    <WorkbookListTable
      workbooks={data.getWorkbooks}
      showServerColumn
      showDatabaseColumn
      onDeleted={() => {
        refetch();
      }}
      toolbar={<NewWorkbookButton />}
    />
  );
};

export default OrganizationWorkbookList;
